import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {
    TheBorderFreeSpinAvalancheWinRunner
} from "../../presentationrunners/freespin/TheBorderFreeSpinAvalancheWinRunner";
import {TheBorderFreeSpinOutroRunner} from "../../presentationrunners/freespin/TheBorderFreeSpinOutroRunner";
import {TheBorderXWaysWinRunner} from "../../presentationrunners/general/TheBorderXWaysWinRunner";
import {TheBorderBigWinRunner} from "../../presentationrunners/general/TheBorderBigWinRunner";
import {TheBorderXSplitWinRunner} from "../../presentationrunners/general/TheBorderXSplitWinRunner";
import {TheBorderXNudgeWinRunner} from "../../presentationrunners/general/TheBorderXNudgeWinRunner";
import {TheBorderSpinEndRunner} from "../../presentationrunners/general/TheBorderSpinEndRunner";
import {TheBorderTotalWinRunner} from "../../presentationrunners/general/TheBorderTotalWinRunner";
import {TheBorderMaxWinRunner} from "../../presentationrunners/general/TheBorderMaxWinRunner";
import {TheBorderXClusterRunner} from "../../presentationrunners/general/TheBorderXClusterRunner";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderFreeSpinWinPresentation implements FlowStatePresentation {

    protected _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new TheBorderXWaysWinRunner(),
            new TheBorderXSplitWinRunner(),
            new TheBorderXNudgeWinRunner(),
            new TheBorderXClusterRunner(),
            new TheBorderFreeSpinAvalancheWinRunner(),
            new TheBorderMaxWinRunner(),
            new TheBorderSpinEndRunner(),
            new TheBorderTotalWinRunner(),
            new TheBorderBigWinRunner(),
            new TheBorderFreeSpinOutroRunner()
        ];
    }

    public start(flowStateController: FlowStateController): void {
        SimplePresentationRunner.run(this._presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}